import { CopyButton, SubRowTable, SubRowTableColumn } from '@psyomics/ui-components';
import { useTranslation } from 'react-i18next';

import { SubmittedReferralSessionResult } from './types';

type Invite = SubmittedReferralSessionResult['invites'][number];

type SubmittedReferralInvitesProps = {
  readonly invites: SubmittedReferralSessionResult['invites'];
};

const SubmittedReferralInvites = ({ invites }: SubmittedReferralInvitesProps) => {
  const { t } = useTranslation();

  const columns: SubRowTableColumn<Invite>[] = [
    {
      header: t('model.common.respondentName'),
      render: (invite) => `${invite.givenName} ${invite.familyName}`,
    },
    {
      header: t('model.common.respondentTypeLabel'),
      render: (invite) => t(`model.common.respondentType.${invite.respondentType}`),
    },
    {
      header: t('page.professionalReferral.home.invites.phoneNumber'),
      render: (invite) => invite.phoneNumber,
    },
    {
      header: t('model.common.status'),
      render: (invite) => t(`model.invite.status.${invite.status}`),
    },
    {
      header: t('model.common.publicId'),
      render: (invite) => invite.publicId,
    },
    {
      header: t('model.common.serviceUserLink'),
      render: (invite) => (
        <CopyButton
          copiedLabel={t('common.buttons.copied')}
          copyLabel={t('common.buttons.copyLink')}
          value={invite.serviceUserLink}
        />
      ),
    },
  ];

  return (
    <SubRowTable columns={columns} emptyMessage={t('page.professionalReferral.home.invites.none')} rows={invites} />
  );
};

export { SubmittedReferralInvites };
